import type { Transcript, TranscriptReference } from '../types/notesTypes';
import { ExamType } from '../constants/gradesContants';

export interface FakeNotesData {
  transcripts: TranscriptReference[];
  transcriptData: Record<string, Transcript>;
}

export const fakeNotesData: FakeNotesData = {
  transcripts: [
    {
      id: 1,
      period: '2024-2025 Semestre 1',
    },
    {
      id: 2,
      period: '2023-2024 Semestre 2',
    },
    {
      id: 3,
      period: '2023-2024 Semestre 1',
    },
  ],
  transcriptData: {
    '1': {
      id: 1,
      period: '2024-2025 Semestre 1',
      subjects: [
        {
          id: 101,
          label: 'Mathématiques Appliquées',
          scores: [
            {
              id: 1001,
              label: 'Partiel',
              value: 15.5,
              maxGrade: 20,
              coefficient: 3,
              examenType: ExamType.Partiel,
              isAverage: false,
              fullAverage: false,
              new: true,
            },
            {
              id: 1002,
              label: 'TP1 - Algèbre',
              value: 17,
              maxGrade: 20,
              coefficient: 1,
              examenType: ExamType.ControleContinu,
              isAverage: false,
              fullAverage: false,
              new: false,
            },
            {
              id: 1003,
              label: 'TP2 - Analyse',
              value: 14,
              maxGrade: 20,
              coefficient: 1,
              examenType: ExamType.ControleContinu,
              isAverage: false,
              fullAverage: false,
              new: false,
            },
          ],
        },
        {
          id: 102,
          label: 'Informatique',
          scores: [
            {
              id: 1004,
              label: 'Projet Final',
              value: 18,
              maxGrade: 20,
              coefficient: 4,
              examenType: ExamType.Rattrapage,
              isAverage: false,
              fullAverage: false,
              new: true,
            },
            {
              id: 1005,
              label: 'TP1 - Algorithmes',
              value: 16,
              maxGrade: 20,
              coefficient: 1,
              examenType: ExamType.ControleContinu,
              isAverage: false,
              fullAverage: false,
              new: false,
            },
            {
              id: 1006,
              label: 'TP2 - Base de données',
              value: 15,
              maxGrade: 20,
              coefficient: 1,
              examenType: ExamType.ControleContinu,
              isAverage: false,
              fullAverage: false,
              new: false,
            },
            {
              id: 1007,
              label: 'Quiz Programmation',
              value: 19,
              maxGrade: 20,
              coefficient: 0.5,
              examenType: ExamType.Evaluation,
              isAverage: false,
              fullAverage: false,
              new: true,
            },
          ],
        },
        {
          id: 103,
          label: 'Physique',
          scores: [
            {
              id: 1008,
              label: 'Examen Final',
              value: 13.5,
              maxGrade: 20,
              coefficient: 3,
              examenType: ExamType.Partiel,
              isAverage: false,
              fullAverage: false,
              new: false,
            },
            {
              id: 1009,
              label: 'Rattrapage',
              value: 16,
              maxGrade: 20,
              coefficient: 3,
              examenType: ExamType.Rattrapage,
              isAverage: false,
              fullAverage: false,
              new: true,
            },
          ],
        },
        {
          id: 104,
          label: 'Anglais',
          scores: [
            {
              id: 1010,
              label: 'Oral',
              value: 17.5,
              maxGrade: 20,
              coefficient: 2,
              examenType: ExamType.Redoublement,
              isAverage: false,
              fullAverage: false,
              new: false,
            },
            {
              id: 1011,
              label: 'Présentation',
              value: 18,
              maxGrade: 20,
              coefficient: 1,
              examenType: ExamType.ControleContinu,
              isAverage: false,
              fullAverage: false,
              new: false,
            },
          ],
        },
        {
          id: 105,
          label: 'Économie',
          scores: [
            {
              id: 1012,
              label: 'Moyenne Générale',
              value: 14.2,
              maxGrade: 20,
              coefficient: 2,
              examenType: ExamType.ControleContinu,
              isAverage: true,
              fullAverage: true,
              new: false,
            },
          ],
        },
      ],
    },
    '2': {
      id: 2,
      period: '2023-2024 Semestre 2',
      subjects: [
        {
          id: 201,
          label: 'Mathématiques Appliquées',
          scores: [
            {
              id: 2001,
              label: 'Partiel',
              value: 14,
              maxGrade: 20,
              coefficient: 3,
              examenType: ExamType.RattrapageRedoublement,
              isAverage: false,
              fullAverage: false,
              new: false,
            },
            {
              id: 2002,
              label: 'TP - Probabilités',
              value: 16.5,
              maxGrade: 20,
              coefficient: 1,
              examenType: ExamType.ControleContinu,
              isAverage: false,
              fullAverage: false,
              new: false,
            },
          ],
        },
        {
          id: 202,
          label: 'Informatique',
          scores: [
            {
              id: 2003,
              label: 'Projet Web',
              value: 17,
              maxGrade: 20,
              coefficient: 4,
              examenType: ExamType.Partiel,
              isAverage: false,
              fullAverage: false,
              new: false,
            },
          ],
        },
      ],
    },
    '3': {
      id: 3,
      period: '2023-2024 Semestre 1',
      subjects: [
        {
          id: 301,
          label: 'Mathématiques',
          scores: [
            {
              id: 3001,
              label: 'Partiel',
              value: 12.5,
              maxGrade: 20,
              coefficient: 3,
              examenType: ExamType.Partiel,
              isAverage: false,
              fullAverage: false,
              new: false,
            },
          ],
        },
      ],
    },
  },
};
